"use sctict";

import {CRIPTOGRAFIA_AES} from "@/constants/geral-constants";

function criptografar(textoAberto, chave, iv) {

    if (!textoAberto) return "O texto original a ser criptografado não foi enviado";
    chave = CRIPTOGRAFIA_AES.CHAVE;
    iv = CRIPTOGRAFIA_AES.VETOR_INICIALIZACAO;

    const cripto = require('crypto');
    const cifrador = cripto.createCipheriv('aes256', chave, iv);
    const textoFechado = cifrador.update(textoAberto, 'utf8', 'hex') + cifrador.final('hex');

    return textoFechado;
}

export default {
    criptografar
};
